import {
    apiRequest,
    PengaturanAccessCreate,
    PengatuanAccessMenuList
} from "../../../../../services/adapters/kepegawaian/accessService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", PengaturanAccessCreate, {
            body: query
        }, true)
    }

    fetchMenu = async (query, cancelToken) => {
        return await apiRequest('get', PengatuanAccessMenuList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository